export const SOFTLINE_FEATURE_KUNDEN_KONDITIONSLISTE = 'kundenKonditionsliste';
export const SOFTLINE_PERMISSION_KUNDENKONDITIONSLISTE = 'KUNDENKONDITIONSLISTE';
